const getLocale = () => {
  const SLMPI18N = Mach.requireModule('Intl');
  const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {};
  return locale;
};

export { getLocale };
